export const initialFilterSafariPackages = {
    park_id: 0,
    month_id: 0,
    stay_category_id:0,
    package_feature:0,
    package_include:0,
    estimated_price_filter_min: 0,
    estimated_price_filter_max:0,
    no_of_safari_min:0,
    no_of_safari_max:0,
    no_of_night_min: 0,
    no_of_night_max: 0
  };

  export const initialFilterSafariPackagesParkWise = {
    month_id: 0,
    stay_category_id:0,
    package_feature:0,
    package_include:0,
    estimated_price_filter_min: 0,
    estimated_price_filter_max:0,
    no_of_safari_min:0,
    no_of_safari_max:0,
    no_of_night_min: 0,
    no_of_night_max: 0
  };
  
  
  export const initialSummary = {
    total: 0,
    page: 1,
    pageSize: 12,
    total_page: 1,
  };